import { VinovaAPIInstance } from '../configVinovaApi';
import { initial } from 'redux/reducers/payment/index';
import { cryptoKey, decryptText } from 'helpers/encrypt';

export const paymentDueApi = async (data: any) => {
  try {
    const res = await VinovaAPIInstance.post(
      `/api/policy/payment-portal/payment-due`,
      data
    );

    if (res['payment-due'][0].error) {
      return { response: res['payment-due'][0].error, error: true };
    } else {
      return res;
    }
  } catch (err) {
    return { response: err.response, error: true };
    // return Promise.reject(err);
  }
};

export const initialPaymentDueApi = async (data: any) => {
  try {
    const res = await VinovaAPIInstance.post(
      `/api/policy/payment-portal/initial-payment-due`,
      data
    );

    if (res['initialpayment-due'][0].error) {
      //Promise.reject(res);
      return { response: res['initialpayment-due'][0].error, error: true };
    } else {
      return res;
    }
  } catch (err) {
    return { response: err.response, error: true };
    // return Promise.reject(err);
  }
};

export const paymentUrlEPFService = async (data: any) => {
  try {
    const res = await VinovaAPIInstance.post(
      `api/Transaction/payment-portal/create-transaction`,
      data
    );

    if (res['success']) {
      window.location.replace(res['data']);
    }
    return res;
  } catch (err) {
    return { response: err.response, error: true };
    // return Promise.reject(err);
  }
};

export const paymentInquiryInfoService = async (data: any) => {
  const paymentInquiryInfo = initial['paymentInquiryInfo'];
  if (data) {
    try {
      const res = await VinovaAPIInstance.get(
        'api/Transaction/payment-portal/get-transaction',
        {
          params: { encryptedId: data },
        }
      );
      paymentInquiryInfo.policyNum = decryptText(
        res.data.REFERENCEID,
        cryptoKey
      ).toString();
      paymentInquiryInfo.owner = `${decryptText(
        res.data.FIRSTNAME,
        cryptoKey
      ).toString()} ${decryptText(
        res.data.MIDDLENAME,
        cryptoKey
      ).toString()} ${decryptText(res.data.LASTNAME, cryptoKey).toString()}`
        .replace(/\s+/g, ' ')
        .trim();
      paymentInquiryInfo.productName = decryptText(
        res.data.DESCRIPTION,
        cryptoKey
      ).toString();
      paymentInquiryInfo.payType = decryptText(
        res.data.PAYMENTTYPE,
        cryptoKey
      ).toString();
      paymentInquiryInfo.clientCode = decryptText(
        res.data.CLIENTCODE,
        cryptoKey
      ).toString();
      paymentInquiryInfo.initialAmount = decryptText(
        res.data.INITIALAMOUNT,
        cryptoKey
      ).toString();
      paymentInquiryInfo.refNo = decryptText(
        res.data.PAYMENTPROVIDERTRANSACTIONID,
        cryptoKey
      ).toString();
      paymentInquiryInfo.settleDate = decryptText(
        res.data.CREATEDON,
        cryptoKey
      ).toString();
      paymentInquiryInfo.amount = decryptText(
        res.data.AMOUNT,
        cryptoKey
      ).toString();
      paymentInquiryInfo.currency = decryptText(
        res.data.CURRENCY,
        cryptoKey
      ).toString();
      paymentInquiryInfo.status = decryptText(
        res.data.STATUS,
        cryptoKey
      ).toString();
      return paymentInquiryInfo;
    } catch (err) {
      //decrypt here
      return { response: err.response, error: true };
    }
  }
};
